module.exports = __webpack_public_path__ + "static/media/Group 59.b66c2001.svg";